import { compose } from 'recompose';
import FinanceReports from './finance-reports.view';

export default compose(FinanceReports);
